export const constant = {
  max_img_width: 2900,
  max_img_height: 1400,
};
